var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.commentInputFocused)?_c('div',[_c('livestream-comment-input')],1):_c('div',[_c('livestream-comment-focus')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }